/**
 * Constant definitions for the component of the list of jobs.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2024-2025
 */

export const SORT_ASCENDING = 'ascending'
export const SORT_DESCENDING = 'descending'
export const FIELD_START_DATETIME = 'job_start_datetime'
export const FIELD_JOB_ID = 'job_id'
export const FIELD_STATUS = 'job_status'
export const FIELD_COST = 'job_cost'
export const FIELD_SERVICE_NAME = 'service_name'
